import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { ThemeProvider } from './contexts/ThemeContext';
import { BibleProvider } from './contexts/BibleContext';
import { AnnotationProvider } from './contexts/AnnotationContext';
import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout/Layout';
import HomePage from './pages/HomePage';
import ReaderPage from './pages/ReaderPage';
import JournalPage from './pages/JournalPage';
import PlansPage from './pages/PlansPage';
import ThemesPage from './pages/ThemesPage';
import BookmarksPage from './pages/BookmarksPage';
import SettingsPage from './pages/SettingsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import SearchPage from './pages/SearchPage';
import BibleRedirect from './pages/BibleRedirect';
import NativeAppBridge from './components/NativeAppBridge';
import UpdateAvailableBanner from './components/UpdateAvailableBanner';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './styles/index.css';

function App() {
  const [waitingRegistration, setWaitingRegistration] = useState(null);

  useEffect(() => {
    serviceWorkerRegistration.register({
      onSuccess: () => {
        console.log('TruthBound is now available offline!');
      },
      onUpdate: (registration) => {
        setWaitingRegistration(registration);
      },
    });
  }, []);

  // Request persistent storage on app start to protect user data
  useEffect(() => {
    async function requestPersistentStorage() {
      if (navigator.storage && navigator.storage.persist) {
        const persisted = await navigator.storage.persisted();
        if (!persisted) {
          // Silently request - browser may grant automatically or require user gesture
          await navigator.storage.persist();
        }
      }
    }
    requestPersistentStorage();
  }, []);

  return (
    <ErrorBoundary>
      <UpdateAvailableBanner
        registration={waitingRegistration}
        onDismiss={() => setWaitingRegistration(null)}
      />
      <ThemeProvider>
        <BibleProvider>
          <AnnotationProvider>
            <Router>
              <NativeAppBridge />
              <Layout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/bible/:bookSlug/:chapterId/:verseId?" element={<BibleRedirect />} />
                  <Route path="/reader" element={<ReaderPage />} />
                  <Route path="/reader/:bookId" element={<ReaderPage />} />
                  <Route path="/reader/:bookId/:chapterId" element={<ReaderPage />} />
                  <Route path="/reader/:bookId/:chapterId/:verseId" element={<ReaderPage />} />
                  <Route path="/journal" element={<JournalPage />} />
                  <Route path="/plans" element={<PlansPage />} />
                  <Route path="/themes" element={<ThemesPage />} />
                  <Route path="/bookmarks" element={<BookmarksPage />} />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/privacy" element={<PrivacyPolicyPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </Router>
            <Analytics />
          </AnnotationProvider>
        </BibleProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
